module.exports = __webpack_public_path__ + "img/text.125b762c.png";